import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/stats/_components/StatsContent.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/game/templates/index.tsx")